export default "__VITE_ASSET__BWC6e4AZ__"